import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "reports/fraud-report",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const fraudReport = require("./FraudReport").default;
          cb(null, fraudReport);
        },
        "FraudReport"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/FraudReport/index.js